<template>
    <div class="comments">
        <div class="comments__header" :class="{'comments__header_expanded': expanded}" @click="expanded = !expanded">
            Развернуть все комментарии
            <div><img src="@/assets/images/expert-panel/down-blue.svg" /></div>
        </div>
        <div class="comments__body">
            <ExpertPanelReviewAssessmentSuperComment
                v-for="(expert, index) of experts"
                :key="expert.id"
                :index="index + 1"
                :value="expert"
                :expanded="expanded"
            />
        </div>
    </div>
</template>

<script>
import ExpertPanelReviewAssessmentSuperComment
    from "@/components/expert-panel-new/review/super/ExpertPanelReviewAssessmentSuperComment.vue";
import {getFio} from "@/tools/tools";

export default {
    name: "ExpertPanelReviewAssessmentSuperComments",
    components: {ExpertPanelReviewAssessmentSuperComment},
    props: {
        session: Object,
    },
    data() {
        return {
            expanded: false,
        };
    },
    computed: {
        experts() {
            return this.mapUsers((this.session.reviewExperts || []).map((reviewExpert) => {
                return {
                    id: reviewExpert.id,
                    userId: reviewExpert.userId,
                    name: '-',
                    comment: reviewExpert.comment,
                };
            }));
        },
    },
    methods: {
        mapUsers(items) {
            const byId = this.$store.getters['users/byId'];
            return items.map((item) => {
                const user = byId(item.userId);
                if (user) {
                    return {...item, name: getFio(user)};
                } else {
                    return {...item};
                }
            });
        },
    },
    mounted() {
        this.$store.dispatch('users/loadMany', this.experts.map(i => i.userId));
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.comments {
  &__header {
    font-weight: 500;
    font-size: rem(16);
    line-height: rem(20);
    color: #4663AB;
    display: flex;
    align-items: center;
    gap: rem(12);
    cursor: pointer;
    margin-bottom: rem(16);
    &_expanded {
      div {
        transform: rotate(180deg);
      }
    }
  }
  &__body {
    padding: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
  }
}
</style>